module.exports = __webpack_public_path__ + "img/LH_Logo_Round_dark.9a7db7e7.png";